import * as React from 'react';
import { Query } from 'react-apollo';

import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import ErrorReporter from 'app/components/ErrorReporter';
import GET_FULL_COACH_SCHEDULE_QUERY from 'coaching/queries/GetFullCoachSchedule.gql';
import {
  GetFullCoachSchedule,
  GetFullCoachSchedule_coaching_getUpcomingSessions,
  GetFullCoachSchedule_coaching_getCoachAvailabilitiesByDay_availabilities,
} from 'coaching/queries/__generated__/GetFullCoachSchedule';

export type CoachUpcomingSession = GetFullCoachSchedule_coaching_getUpcomingSessions;

export type Props = {
  coachUuid?: string;
  startDate: string;
  endDate: string;
  timezone?: string;
  children: (props: {
    upcomingSessions: CoachUpcomingSession[];
    availabilities: GetFullCoachSchedule_coaching_getCoachAvailabilitiesByDay_availabilities[];
  }) => React.ReactNode;
};

export default function GetFullCoachScheduleContainer(props: Props) {
  if (!props.coachUuid) {
    return (
      <ErrorReporter error="GetFullCoachScheduleContainer - tried to fetch coach schedule without coachUuid">
        Unable to retrieve the coach’s schedule - please refresh and try again.
      </ErrorReporter>
    );
  }

  return (
    <Query<GetFullCoachSchedule>
      query={GET_FULL_COACH_SCHEDULE_QUERY}
      variables={{
        coachUuid: props.coachUuid,
        startDate: props.startDate,
        endDate: props.endDate,
        timezone: props.timezone,
      }}
      errorPolicy="all">
      {({ loading, error, data }) => {
        if (loading) {
          return <CenteredLoadingIndicator />;
        }

        return (
          <>
            {!data?.coaching_getUpcomingSessions && (
              <ErrorReporter error={`Unable to fetch upcoming sessions error=${error?.message}`}>
                Unable to fetch upcoming sessions
              </ErrorReporter>
            )}
            {!data?.coaching_getCoachAvailabilitiesByDay?.availabilities && (
              <ErrorReporter error={`Unable to fetch coach availabilities error=${error?.message}`}>
                Unable to fetch coach availability
              </ErrorReporter>
            )}
            {props.children({
              upcomingSessions: data?.coaching_getUpcomingSessions ?? [],
              availabilities: data?.coaching_getCoachAvailabilitiesByDay?.availabilities ?? [],
            })}
          </>
        );
      }}
    </Query>
  );
}
